module.exports = __webpack_public_path__ + "static/media/sports_team.abca02ea.webp";